import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

// ui
import AdminTemplate from "@components/templates/AdminTemplate";
import RecordBatchPrinting from "@components/organisms/mgr/common/record/RecordBatchPrinting";
import { RecordEachUser } from "@components/organisms/mgr/TANKINYUSHO/record/RecordEachUser";

// store
import { connect } from "react-redux";
import { Dispatch } from "redux";
import dispatches from "@stores/dispatches";
import { unsetUsersSummaryTANKINYUSHO } from "@stores/domain/mgr/TANKINYUSHO/usersSummary/actions";

type DispatchProps = {
  fetchUsers: () => Promise<void>;
  unsetUsersSummary: () => void;
};

type Props = RouteComponentProps & DispatchProps;

/**
 * 利用者サマリ
 */
const RecordUsersSummaryCore = (props: Props): JSX.Element => {
  React.useEffect(() => {
    props.fetchUsers();
  }, []);

  // 一括印刷のデフォルト項目上書き指定
  const options = [
    { label: "記録を選択", value: "" },
    { label: "支援記録", value: "supportB" }
  ];

  return (
    <AdminTemplate pageName="利用者ごと">
      {/* 記録の一括印刷 */}
      <RecordBatchPrinting
        history={props.history}
        defaultSelected="supportB"
        options={options}
        isUseCustomRecord
        unsetUsersSummary={props.unsetUsersSummary}
      />
      {/* 利用ごとの記録 */}
      <RecordEachUser />
    </AdminTemplate>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  const { TANKINYUSHO } = dispatches;
  const userInFacilityDispatcher = TANKINYUSHO.userInFacilityDispatcher(
    dispatch
  );
  return {
    fetchUsers: (): Promise<void> => userInFacilityDispatcher.fetch(),
    unsetUsersSummary: (): void => {
      dispatch(unsetUsersSummaryTANKINYUSHO());
    }
  };
};

export const RecordUsersSummary = connect(
  null,
  mapDispatchToProps
)(RecordUsersSummaryCore);
